/**
 * 路由设置
 */
import { UserLayout, BasicLayout, BlankLayout } from '@/views/layouts'

const RouteView = {
  name: 'RouteView',
  render: h => h('router-view')
}

/**
 * 异步路由
 * @type { *[] }
 */
export const asyncRouterMap = [

]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/',
    component: BasicLayout,
    redirect: '/',
    children: [
      {
        path: '/',
        name: 'index',
        component: () => import('@/views/index/Index'),      //  首页
        meta: {
          title: '首页',
          showPPT: true,
        }
      },
      {
        path: '/search',
        name: 'search',
        component: () => import('@/views/search/Search'),    //  搜索页
        meta: {
          title: '搜索',
          showPPT: true,
        }
      },
      {
        path: '/ppt',
        name: 'PPT',
        component: () => import('@/views/ppt/PPT'),         //  PPT商品库
        meta: {
          title: 'PPT商品库',
          showPPT: true,
        }
      },
      {
        path: '/cart',
        name: 'cart',
        component: () => import('@/views/cart/Cart'),        //  购物车页
        meta: {
          title: '购物车',
          showPPT: true,
        }
      },
      {
        path: '/checkout',
        name: 'checkout',
        component: () => import('@/views/order/Checkout'),   //  订单确认页
        meta: {
          title: '确认订单',
          showPPT: true,
        }
      },
      {
        path: '/case',
        name: 'case',
        // component: () => import('@/views/public/Article'),     //  成功案例
        component: () => import('@/views/successcases/SuccessCases'),     //  成功案例
        meta: {
          title: '成功案例',
          showPPT: true,
          flag_id: 5,
        }
      },
      {
        path: '/about',
        name: 'about',
        component: () => import('@/views/public/About'),     //  关于我们
        meta: {
          title: '关于我们',
          showPPT: true,
          flag_id: 1,
        }
      },
      {
        path: '/service',
        name: 'serviceTerms',
        component: () => import('@/views/public/Article'),     //  服务条款
        meta: {
          title: '服务条款',
          showPPT: true,
          flag_id: 2,
        }
      },
      {
        path: '/privacy',
        name: 'privacy',
        component: () => import('@/views/public/Article'),          //  隐私政策
        meta: {
          title: '隐私政策',
          showPPT: true,
          flag_id: 3,
        }
      },
      {
        path: '/protocol',
        name: 'protocol',
        component: () => import('@/views/public/Article'),          //  用户服务协议
        meta: {
          title: '用户服务协议',
          showPPT: true,
          flag_id: 8,
        }
      },
      {
        path: '/guide',
        name: 'guide',
        component: () => import('@/views/public/Article'),          //  购物指南
        meta: {
          title: '购物指南',
          showPPT: true,
          flag_id: 6,
        }
      },
      // {
      //   path: '/explain',
      //   name: 'explain',
      //   component: () => import('@/views/public/Article'),          //  定制说明
      //   meta: {
      //     title: '定制说明',
      //     showPPT: true,
      //   }
      // },
      {
        path: '/question',
        name: 'question',
        component: () => import('@/views/public/Article'),          //  常见问题
        meta: {
          title: '常见问题',
          showPPT: true,
          flag_id: 7,
        }
      },
      {
        path: '/order-process',
        name: 'orderProcess',
        component: () => import('@/views/public/OrderProcess'),     //  企业礼品定制
        meta: {
          title: '企业礼品定制',
          showPPT: false,
        }
      },
      {
        path: '/sbrand-feedback',
        name: 'sbrandFeedback',
        component: () => import('@/views/public/SbrandFeedback'),     //  其他服务品牌需求反馈
        meta: {
          title: '企业礼品定制',
          showPPT: false,
        }
      },
    ]
  },
  //  品牌
  {
    path: '/brand',
    component: BasicLayout,
    redirect: 'brand',
    children: [
      {
        path: '/brand',
        name: 'brandIndex',
        component: () => import('@/views/brand/Index'),      //  品牌页
        meta: {
          title: '品牌礼品',
          showPPT: true,
        }
      },
      {
        path: '/brand/list',
        name: 'brandyList',
        component: () => import('@/views/brand/List'),       //  品牌列表页
        meta: {
          title: '品牌商品',
          showPPT: true,
        }
      },
    ]
  },
  //  商品
  {
    path: '/goods',
    component: BasicLayout,
    redirect: '/goods/index',
    children: [
      {
        path: '/goods/index',
        name: 'goodsIndex',
        component: () => import('@/views/goods/Index'),      //  商品首页
        meta: {
          title: '商品首页',
          showPPT: true,
        }
      },
      {
        path: '/goods/list',
        name: 'goodsList',
        component: () => import('@/views/goods/List'),       //  商品列表页
        meta: {
          title: '商品列表',
          showPPT: true,
        }
      },
      {
        path: '/goods/detail',
        name: 'goodsDetail',
        component: () => import('@/views/goods/Detail'),     //  商品详情页
        meta: {
          title: '商品详情',
          showPPT: true,
        }
      }
    ]
  },
  {
    path: '/article',
    component: BasicLayout,
    redirect: '/article/index',
    children: [
      {
        path: '/article/index',
        name: 'articleIndex',
        component: () => import('@/views/article/Index'),      //  文章首页
        meta: {
          title: '文章首页',
          showPPT: true,
        }
      },
      {
        path: '/article/list',
        name: 'articleList',
        component: () => import('@/views/article/List'),       //  文章列表页
        meta: {
          title: '文章列表',
          showPPT: true,
        }
      },
      {
        path: '/article/detail',
        name: 'articleDetail',
        component: () => import('@/views/article/Detail'),     //  文章详情页
        meta: {
          title: '文章详情',
          showPPT: true,
        }
      }
    ]
  },
  //  em
  {
    path: '/em',
    component: BasicLayout,
    redirect: '/em/presale',
    children: [
      {
        path: '/em/presale',
        name: 'emPresale',
        component: () => import('@/views/em/Presale'),      //  预售页
        meta: {
          title: '周边文创',
          showPPT: true,
        }
      },
      {
        path: '/em/sale',
        name: 'emSale',
        component: () => import('@/views/em/Sale'),         //  现货页
        meta: {
          title: '周边文创',
          showPPT: true,
        }
      },
    ]
  },
  //  分类
  {
    path: '/category',
    component: BasicLayout,
    redirect: '/category/list',
    children: [
      {
        path: '/category',
        name: 'categoryIndex',
        component: () => import('@/views/category/Index'),   //  分类页
        meta: {
          title: '分类页',
          showPPT: true,
        }
      },
      {
        path: '/category/list',
        name: 'categoryList',
        component: () => import('@/views/category/List'),    //  礼品定制页（分类列表页）
        meta: {
          title: '非库存商品',
          showPPT: true,
        }
      },
    ]
  },
  //  标签
  {
    path: '/ip',
    component: BasicLayout,
    redirect: '/ip',
    children: [
      {
        path: '/ip',
        name: 'ipIndex',
        component: () => import('@/views/ip/Index'),          //  特色IP
        meta: {
          title: '特色IP',
          showPPT: true,
        }
      },
      {
        path: '/ip/category',
        name: 'ipCategory',
        component: () => import('@/views/ip/Category'),     //  标签分类页
        meta: {
          title: '标签分类',
          showPPT: true,
        }
      },
      {
        path: '/ip/list',
        name: 'ipList',
        component: () => import('@/views/ip/List'),         //  标签列表页
        meta: {
          title: '标签列表',
          showPPT: true,
        }
      },
      {
        path: '/ip/detail',
        name: 'ipDetail',
        component: () => import('@/views/ip/Detail'),       //  标签详情页
        meta: {
          title: '标签详情',
          showPPT: true,
        }
      },
    ]
  },
  //  标签
  {
    path: '/tag',
    component: BasicLayout,
    redirect: '/tag',
    children: [
      {
        path: '/tag',
        name: 'tagIndex',
        component: () => import('@/views/tag/Index'),        //  标签首页
        meta: {
          title: '标签页',
          showPPT: true,
        }
      },
      {
        path: '/tag/category',
        name: 'tagCategory',
        component: () => import('@/views/tag/Category'),     //  标签分类页
        meta: {
          title: '标签分类',
          showPPT: true,
        }
      },
      {
        path: '/tag/list',
        name: 'tagList',
        component: () => import('@/views/tag/List'),         //  标签列表页
        meta: {
          title: '标签列表',
          showPPT: true,
        }
      },
      {
        path: '/tag/detail',
        name: 'tagDetail',
        component: () => import('@/views/tag/Detail'),       //  标签详情页
        meta: {
          title: '标签详情',
          showPPT: true,
        }
      },
    ]
  },
  //  登录 - 注册
  {
    path: '/auth',
    component: BlankLayout,
    redirect: '/auth/login',
    children: [
      {
        path: '/auth/login',
        name: 'login',
        component: () => import('@/views/auth/Login'),       //  登录页
        meta: {
          title: '登录'
        }
      },
      {
        path: '/auth/register',
        name: 'register',
        component: () => import('@/views/auth/Register'),    //  注册页
        meta: {
          title: '注册'
        }
      },
      {
        path: '/auth/forget',
        name: 'register',
        component: () => import('@/views/auth/Rorget'),    //  忘记密码
        meta: {
          title: '忘记密码'
        }
      }
    ]
  },
  {
    path: '/sso',
    name: 'sso',
    component: () => import('@/views/auth/Sso'),       //  单点登录回调页
    meta: {
      title: '单点登录'
    }
  },
  //  用户
  {
    path: '/user',
    component: BasicLayout,
    redirect: '/user',
    children: [
      {
        path: '/user',
        name: 'userIndex',
        component: () => import('@/views/user/Index'),    //  用户首页
        meta: {
          title: '用户首页',
          showPPT: true,
        }
      },
      {
        path: '/user/invoice',
        name: 'userInvoice',
        component: () => import('@/views/user/userInvoice'),    //  开票信息
        meta: {
          title: '开票信息',
          showPPT: true,
        }
      },
      {
        path: '/user/address',
        name: 'userAddress',
        component: () => import('@/views/user/UserAddress'),    //  用户地址
        meta: {
          title: '用户地址管理',
          showPPT: true,
        }
      },
      {
        path: '/user/reset-password',
        name: 'resetPassword',
        component: () => import('@/views/user/UserResetPassword'),    //  重置密码
        meta: {
          title: '修改密码',
          showPPT: true,
        }
      }
    ]
  },
  //  订单中心
  {
    path: '/order',
    component: BasicLayout,
    redirect: '/order',
    children: [
      {
        path: '/order',
        name: 'orderIndex',
        component: () => import('@/views/order/Index'),   //  订单中心
        meta: {
          title: '订单中心',
          showPPT: true,
        }
      },
      {
        path: '/order/payment',
        name: 'orderPayment',
        component: () => import('@/views/order/Payment'),   //  订单支付
        meta: {
          title: '订单支付',
          showPPT: false,
        }
      },
      {
        path: '/order/punchout',
        name: 'punchout',
        component: () => import('@/views/order/Punchout'),   //  Punchout 页面
        meta: {
          title: '提交数据到采购商城',
          showPPT: true,
        }
      },
      {
        path: '/order/detail',
        name: 'orderDetail',
        component: () => import('@/views/order/Detail'),   //  订单详情
        meta: {
          title: '订单详情',
          showPPT: true,
        }
      },
    ]
  },
  // Exception
  {
    path: '/exception',
    name: 'exception',
    component: RouteView,
    redirect: '/exception/403',
    children: [
      {
        path: '/exception/403',
        name: 'Exception403',
        component: () => import('@/views/exception/403'),     //  403页面
        meta: {
          title: '403页面'
        }
      },
      {
        path: '/exception/404',
        name: 'Exception404',
        component: () => import('@/views/exception/404'),     //  404页面
        meta: {
          title: '404页面'
        }
      },
      {
        path: '/exception/500',
        name: 'Exception500',
        component: () => import('@/views/exception/500'),     //  500页面
        meta: {
          title: '500页面'
        }
      }
    ]
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/error/404.vue'),         //  通用404页面
    meta: {
      title: '404页面'
    }
  },
  {
    path: '*',
    redirect: '/404'  //  无法找到的路由直接跳转到404页面
  },
]

/**
 * 登录状态下不能访问的列表
 * @type { *[] }
 */
export const loginRefuseList = [
  'login',
  'register',
  'forget',
]

/**
 * 未登录状态不能访问的列表
 * @type { *[] }
 */
export const loginAllowList = [
  'ppt',
  'cart',
  'checkout',
  'punchout',
  'userIndex',
  'userAddress',
  'userInvoice',
  'orderIndex',
  'orderDetail',
]
